const styles = (theme) => ({
  containerPaper: {
    width: "100%",

    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
    gap: 1,
    backgroundColor: theme.palette.background.wallpaper,
  },
  containerHeader: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  containerHeaderUser: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    opacity: 0.7,
  },
  chip: {
    fontWeight: "bold",
    color: theme.palette.white.main,
    borderRadius: "6px",
    maxWidth: "350px",
    "& .MuiChip-label": {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },

  titleUsers: { fontSize: "12px", fontWeight: "bold" },
  description: {
    fontSize: "12px",
    wordBreak: "break-word",
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
  },
  boxDescription: {
    display: "flex",
    justifyContent: "space-between",
    gap: 2,
    alignItems: "flex-start",
  },
  containerInfo: {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
  },
  icon: {
    fontSize: "18px",
    marginRight: "4px",
  },
  paperPermissao: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    borderRadius: "8px",
    p: 2,
    flexDirection: "column",
  },
});

export default styles;
